import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 0CB92EB7-2EE0-401C-9113-7D52E78DB51E
 * name window-close
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/window-close.svg
 * tags
 */
export const WindowCloseIcon = createSvgIcon(<><path d="M13.46,12L19,17.54V19H17.54L12,13.46L6.46,19H5V17.54L10.54,12L5,6.46V5H6.46L12,10.54L17.54,5H19V6.46L13.46,12Z" /></>, 'WindowCloseIcon');
export default WindowCloseIcon